<template>
  	<FlexSinglePinActivation />
</template>

<script>

// @ is an alias to /src
import FlexSinglePinActivation from "@/components/Flex/SinglePinActivation.vue";
export default {
  name: "FlexSinglePinActivations",
  components: {
    FlexSinglePinActivation,
  },
};
</script>
